import Product from "views/Product.js";
import Categories from "views/Categories.js";
import Transactions from "views/Transactions.js";
import PendingTransactions from "views/PendingTransactions.js";
import SalesReport from "views/SalesReport.js";
import Promotion from "views/Promotion.js";
import Settings from "views/Settings.js";
import Dashboard from "views/Dashboard/Dashboard.js";
import Machines from "views/Machines.js";
import MachineDetail from "views/MachineDetail.js";
import Advertising from "views/Advertising.js";
import ActivitiesLogs from "views/ActivitiesLogs.js";
import SlotsPage from "views/SlotModal/SlotsPage";
import Layers from "views/Layers";
import MachineStatus from "views/MachineStatus.js";
import SingleLayers from "views/Layers/SingleLayers";
import CreativeVideoAssignments from "views/CreativeVideoAssignments";
import CurrencyConverter from "views/CurrencyConverter";
import Alerts from "views/Alert";



const dashboardRoutes = [
  {
    path: "/dashboard",
    name: "Dashboard",
    icon: "nc-icon nc-chart-pie-35",
    component: Dashboard,
    layout: "/admin",
  },
  {
    path: "/product",
    name: "Product",
    icon: "nc-icon nc-bag-16",
    component: Product,
    layout: "/admin",
  },
  {
    path: "/product/list",
    name: "Product List",
    component: Product,
    layout: "/admin",
  },
  {
    path: "/product/add",
    name: "Add Product",
    component: Product,
    layout: "/admin",
  },
  {
    path: "/product/categories",
    name: "Categories",
    component: Categories,
    layout: "/admin",
  },
  {
    path: "/machines",
    name: "Machines",
    icon: "nc-icon nc-tv-2",
    component: Machines,
    layout: "/admin",
  },
  {
    path: "/machines/:machineId",
    name: "Machine Detail",
    component: MachineDetail,
    layout: "/admin",
  },
  {
    path: "/machines/list",
    name: "Machine List",
    component: Machines,
    layout: "/admin",
  }, {
    path: "/machines/slots/:machineId",
    name: "Machine List",
    component: SlotsPage,
    layout: "/admin",
  }, {
    path: "/machines/layers/:machineId",
    name: "Layers",
    component: Layers,
    layout: "/admin",
  }, {
    path: "/machines/layers/:machineId/:layerId",
    name: "Layers",
    component: SingleLayers,
    layout: "/admin",
  },
  {
    path: "/machines/add",
    name: "Add Machine",
    component: Machines,
    layout: "/admin",
  },
  {
    path: "/machines/status",
    name: "Machine Status",
    component: MachineStatus,
    layout: "/admin",
  },
  {
    path: "/transactions",
    name: "Transactions",
    icon: "nc-icon nc-money-coins",
    component: Transactions,
    layout: "/admin"
  },
  {
    path: "/transactions/list",
    name: "Transaction List",
    component: Transactions,
    layout: "/admin"
  },
  {
    path: "/transactions/pending",
    name: "Pending Transactions",
    component: Transactions,
    layout: "/admin"
  },
  {
    path: "/transactions/history",
    name: "Transaction History",
    component: Transactions,
    layout: "/admin"
  },
  {
    path: "/sales-report",
    name: "Sales Report",
    icon: "nc-icon nc-chart-bar-32",
    component: SalesReport,
    layout: "/admin"
  },
  {
    path: "/creative/videos",
    name: "Creative  Management",
    icon: "nc-icon nc-button-play",
    component: CreativeVideoAssignments,
    layout: "/admin"
  },
  {
    path: "/currency-converter",
    name: "Currency Converter",
    icon: "nc-icon nc-money-coins",
    component: CurrencyConverter,
    layout: "/admin"
  },
  {
    path: "/advertising",
    name: "Advertising",
    icon: "nc-icon nc-send",
    component: Advertising,
    layout: "/admin"
  },
  {
    path: "/promotion",
    name: "Promotion",
    icon: "nc-icon nc-tag-content",
    component: Promotion,
    layout: "/admin"
  },
  {
    path: "/activities-logs",
    name: "Activities Logs",
    icon: "nc-icon nc-paper-2",
    component: ActivitiesLogs,
    layout: "/admin"
  },
  {
    path: "/settings",
    name: "Settings",
    icon: "nc-icon nc-settings-gear-64",
    component: Settings,
    layout: "/admin",
  },

  {
    path: "/dashboard/alerts",
    name: "Product Alerts",
    icon: "nc-icon nc-bell-55",
    component:Alerts,
    layout: "/admin",
  }
];

export default dashboardRoutes;
